import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/solicita-una-auditoria")({
  head: () => buildRouteHead("/es/solicita-una-auditoria", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/solicita-tu-auditoria", replace: true });
  },
});
